/* eslint-disable no-unused-vars */
// needed since color isn't used in the template but appears in the replaced body
import React from "react";
import PropTypes from "prop-types";

/*
 * Yuka v2.0
 * This component corresponds to ``file-plus.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */
const FilePlusIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 18 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="evenodd"
        d="M6.56903 0.75H11.431C12.0347 0.749991 12.533 0.749983 12.9389 0.783146C13.3604 0.81759 13.748 0.891513 14.112 1.07698C14.6765 1.3646 15.1354 1.82354 15.423 2.38803C15.6085 2.75203 15.6824 3.13956 15.7169 3.56113C15.75 3.96702 15.75 4.46529 15.75 5.06901V7.875C15.75 8.28921 15.4142 8.625 15 8.625C14.5858 8.625 14.25 8.28921 14.25 7.875V5.1C14.25 4.45757 14.2494 4.02085 14.2218 3.68328C14.195 3.35447 14.1463 3.18631 14.0865 3.06901C13.9427 2.78677 13.7132 2.5573 13.431 2.41349C13.3137 2.35372 13.1455 2.30503 12.8167 2.27816C12.4792 2.25058 12.0424 2.25 11.4 2.25H6.6C5.95757 2.25 5.52085 2.25058 5.18328 2.27816C4.85447 2.30503 4.68631 2.35372 4.56902 2.41349C4.28677 2.5573 4.0573 2.78677 3.91349 3.06902C3.85372 3.18631 3.80503 3.35447 3.77816 3.68328C3.75058 4.02085 3.75 4.45757 3.75 5.1V12.9C3.75 13.5424 3.75058 13.9792 3.77816 14.3167C3.80503 14.6455 3.85372 14.8137 3.91349 14.931C4.0573 15.2132 4.28677 15.4427 4.56902 15.5865C4.68631 15.6463 4.85447 15.695 5.18328 15.7218C5.52085 15.7494 5.95757 15.75 6.6 15.75H9C9.41421 15.75 9.75 16.0858 9.75 16.5C9.75 16.9142 9.41421 17.25 9 17.25H6.56901C5.96529 17.25 5.46702 17.25 5.06113 17.2169C4.63956 17.1824 4.25203 17.1085 3.88803 16.923C3.32354 16.6354 2.8646 16.1765 2.57698 15.612C2.39151 15.248 2.31759 14.8604 2.28315 14.4389C2.24998 14.033 2.24999 13.5347 2.25 12.931V5.06903C2.24999 4.4653 2.24998 3.96703 2.28315 3.56113C2.31759 3.13956 2.39151 2.75203 2.57698 2.38803C2.8646 1.82354 3.32354 1.3646 3.88803 1.07698C4.25203 0.891513 4.63956 0.81759 5.06113 0.783146C5.46703 0.749983 5.9653 0.749991 6.56903 0.75ZM5.25 5.25C5.25 4.83579 5.58579 4.5 6 4.5H12C12.4142 4.5 12.75 4.83579 12.75 5.25C12.75 5.66421 12.4142 6 12 6H6C5.58579 6 5.25 5.66421 5.25 5.25ZM5.25 8.25C5.25 7.83579 5.58579 7.5 6 7.5H10.5C10.9142 7.5 11.25 7.83579 11.25 8.25C11.25 8.66421 10.9142 9 10.5 9H6C5.58579 9 5.25 8.66421 5.25 8.25ZM5.25 11.25C5.25 10.8358 5.58579 10.5 6 10.5H7.5C7.91421 10.5 8.25 10.8358 8.25 11.25C8.25 11.6642 7.91421 12 7.5 12H6C5.58579 12 5.25 11.6642 5.25 11.25ZM13.5 10.5C13.9142 10.5 14.25 10.8358 14.25 11.25V12.75H15.75C16.1642 12.75 16.5 13.0858 16.5 13.5C16.5 13.9142 16.1642 14.25 15.75 14.25H14.25V15.75C14.25 16.1642 13.9142 16.5 13.5 16.5C13.0858 16.5 12.75 16.1642 12.75 15.75V14.25H11.25C10.8358 14.25 10.5 13.9142 10.5 13.5C10.5 13.0858 10.8358 12.75 11.25 12.75H12.75V11.25C12.75 10.8358 13.0858 10.5 13.5 10.5Z"
        transform=""
      />
    </g>
  </svg>
);

FilePlusIcon.propTypes = {
  // all of these can be overriden in CSS as necessary
  color: PropTypes.string,
  size: PropTypes.number,
};

FilePlusIcon.defaultProps = {
  color: "#ffffff",
  size: 16,
};

FilePlusIcon.displayName = "FilePlusIcon";

export default FilePlusIcon;
